<template>
  <div class="animated fadeIn">
    <div>
      <component-header
        title="My Unbilled Invoice"
        @reload-data="getPartnerInvoiceListData"
        :isLoading="isloading"
        :hasCreate="false"
        :hasback="true"
        @back-press="$router.push('/myaccount/my-invoice')"
        @search-query="val => (filter = val)"
      />
      <b-card class="card-wrap" border-variant="info">
        <div>
          <b-table
            :dark="false"
            :hover="true"
            :striped="false"
            :bordered="true"
            :filter="filter"
            :small="false"
            :fixed="false"
            responsive="sm"
            :items="invoiceList"
            :fields="invoiceColumns"
            :current-page="currentPage"
            :per-page="perPage"
            thead-class="header"
            show-empty
          >
            <template slot="status" slot-scope="data">
              <p>
                <img src="img/Ellipse63.png" alt="" /> {{ data.item.status }}
              </p>
            </template>
            <template slot="empty">
              <div v-if="isloading" class="text-center">
                <span><b>Loading...</b></span>
              </div>
              <div v-else class="text-center">
                No data available.
              </div>
            </template>
          </b-table>
        </div>
        <div class="float-right">
          <b-pagination
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="invoiceList.length"
            aria-controls="my-table"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          ></b-pagination>
        </div>
      </b-card>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ebButton from "@/components/FormElements/Button";
import ComponentHeader from "@/components/componentNewHeader";
import loader from "@/components/loader/nipigeloader.vue";
import moment from "moment";
export default {
  name: "UnbilledInvoice",
  components: {
    ebButton,
    ComponentHeader,
    loader
  },
  data() {
    return {
      loading: true,
      isloading: false,
      filter: "",
      currentPage: 1,
      perPage: 10,
      invoiceColumns: [
        {
          key: "id"
        },
        {
          key: "chargedDate"
        },
        {
          key: "eventType"
        },
        {
          key: "orderNumber"
        },
        {
          key: "orderAmount"
        },
        {
          key: "total"
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      getPartnerMyUnbilledInvoice: "invoice/GetPartnerMyUnbilledInvoice"
    }),

    invoiceList() {
      let data = this.getPartnerMyUnbilledInvoice;
      let invoiceList = [];
      if (Array.isArray(data) && data.length > 0) {
        data.map(obj => {
          let num = obj.chargeRef.toString();
          while (num.length < 10) num = "0" + num;
          let arrObj = {
            //     _id: obj._id,
            id: "#" + num,
            chargedDate: this.getProperDate(obj.createdAt),
            eventType: obj.eventType ? obj.eventType : obj.cadence,
            orderNumber: obj.eventRefId ? obj.eventRefId : obj.subscription,
            orderAmount: obj.chargedOn
              ? obj.chargedOn
              : obj.itemTotal.toFixed(2),
            total: obj.itemTotal.toFixed(2),
            restData: obj
          };
          invoiceList.push(arrObj);
        });
        return invoiceList.sort(
          (a, b) =>
            new Date(b.restData.updatedAt) - new Date(a.restData.updatedAt)
        );
      } else {
        return [];
      }
    }
  },
  methods: {
    async getPartnerInvoiceListData() {
      this.isloading = true;
      await this.$store
        .dispatch("invoice/fetchPartnerMyUnbilledInvoice")
        .then(() => (this.isloading = false))
        .catch(() => (this.isloading = false));
    },
    getProperDate(data) {
      if (data != null) {
        let date = new Date(data);

        return moment(String(date)).format("MM/DD/YYYY");
      } else {
        return "Unavailable";
      }
    }
  },

  async mounted() {
    this.isloading = true;
    await this.$store
      .dispatch("invoice/fetchPartnerMyUnbilledInvoice")
      .then(() => (this.isloading = false))
      .catch(() => (this.isloading = false));
  }
};
</script>
